import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <CommentsSection />
        <ContactSection />
        <IndexSection />
        <FeaturesSection />
        <TopicsSection />
        <FaqSection />
        <UpdatesSection />
        <RankingSection />
        <CardsSection />
        <AppSection />
        <CarouselSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}